var _mask, _path, _path2, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIphone14Clay3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 800,
    viewBox: "0 0 1365 2488",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_654_24595",
    maskUnits: "userSpaceOnUse",
    x: 14.3477,
    y: 0,
    width: 1337,
    height: 2488,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 14.3477,
    width: 1337,
    height: 2488
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.474 2C101.918 2 16.3477 77.9672 16.3477 171.678V2316.32C16.3477 2410.03 101.918 2486 207.474 2486H1157.53C1263.08 2486 1348.65 2410.03 1348.65 2316.32V171.678C1348.65 77.9672 1263.08 2 1157.53 2H207.474ZM230 82C150.471 82 86 146.471 86 226V2264C86 2343.53 150.471 2408 230 2408H1135C1214.53 2408 1279 2343.53 1279 2264V226C1279 146.471 1214.53 82 1135 82H230Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.474 2C101.918 2 16.3477 77.9672 16.3477 171.678V2316.32C16.3477 2410.03 101.918 2486 207.474 2486H1157.53C1263.08 2486 1348.65 2410.03 1348.65 2316.32V171.678C1348.65 77.9672 1263.08 2 1157.53 2H207.474ZM230 82C150.471 82 86 146.471 86 226V2264C86 2343.53 150.471 2408 230 2408H1135C1214.53 2408 1279 2343.53 1279 2264V226C1279 146.471 1214.53 82 1135 82H230Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3477 171.678C18.3477 79.2889 102.792 4 207.474 4V0C101.044 0 14.3477 76.6455 14.3477 171.678H18.3477ZM18.3477 2316.32V171.678H14.3477V2316.32H18.3477ZM207.474 2484C102.792 2484 18.3477 2408.71 18.3477 2316.32H14.3477C14.3477 2411.35 101.044 2488 207.474 2488V2484ZM1157.53 2484H207.474V2488H1157.53V2484ZM1346.65 2316.32C1346.65 2408.71 1262.21 2484 1157.53 2484V2488C1263.96 2488 1350.65 2411.35 1350.65 2316.32H1346.65ZM1346.65 171.678V2316.32H1350.65V171.678H1346.65ZM1157.53 4C1262.21 4 1346.65 79.2889 1346.65 171.678H1350.65C1350.65 76.6455 1263.96 0 1157.53 0V4ZM207.474 4H1157.53V0H207.474V4ZM88 226C88 147.576 151.576 84 230 84V80C149.366 80 84 145.366 84 226H88ZM88 2264V226H84V2264H88ZM230 2406C151.576 2406 88 2342.42 88 2264H84C84 2344.63 149.366 2410 230 2410V2406ZM1135 2406H230V2410H1135V2406ZM1277 2264C1277 2342.42 1213.42 2406 1135 2406V2410C1215.63 2410 1281 2344.63 1281 2264H1277ZM1277 226V2264H1281V226H1277ZM1135 84C1213.42 84 1277 147.576 1277 226H1281C1281 145.366 1215.63 80 1135 80V84ZM230 84H1135V80H230V84Z",
    fill: "#F9F9FB",
    mask: "url(#path-1-outside-1_654_24595)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_654_24595)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 911.496,
    width: 13.3344,
    height: 194.015,
    rx: 3.94599,
    fill: "#F9F9FB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_654_24595)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.74707,
    y: 674.254,
    width: 13.3344,
    height: 196.026,
    rx: 3.94599,
    fill: "#F9F9FB"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_654_24595)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.74707,
    y: 491.297,
    width: 13.3344,
    height: 105.552,
    rx: 3.94599,
    fill: "#F9F9FB"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_654_24595)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1350.92,
    y: 739.594,
    width: 13.3344,
    height: 297.557,
    rx: 3.94599,
    fill: "#F9F9FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_654_24595",
    x: 2.0135,
    y: 911.496,
    width: 16.294,
    height: 194.016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.986497
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.46624
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_654_24595"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.97299
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.986497
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_654_24595",
    result: "effect2_innerShadow_654_24595"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_654_24595",
    x: -0.239427,
    y: 674.254,
    width: 16.294,
    height: 196.027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.986497
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.46624
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_654_24595"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.97299
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.986497
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_654_24595",
    result: "effect2_innerShadow_654_24595"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_654_24595",
    x: -0.239427,
    y: 491.297,
    width: 16.294,
    height: 105.551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.986497
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.46624
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_654_24595"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.97299
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.986497
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_654_24595",
    result: "effect2_innerShadow_654_24595"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_654_24595",
    x: 1348.95,
    y: 739.594,
    width: 16.2935,
    height: 297.559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.986497
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.46624
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_654_24595"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.97299
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.986497
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_654_24595",
    result: "effect2_innerShadow_654_24595"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone14Clay3);
export default __webpack_public_path__ + "static/media/iphone_14_clay_3.8f3ca6c0f0e84eec186cc88d427d3ec8.svg";
export { ForwardRef as ReactComponent };